import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import CurdService from '../../admin/adminServices/curd.services'
import { setMessage } from './message'

const modle = "imgdata"

export const createImgData = createAsyncThunk(
  'imgData/addImg', async (arg, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    try {
      const res = await CurdService.create(modle, { imgUrl: arg.imgUrl, imgDesc: arg.imgDesc })
      return (res.data)
    }
    catch (error) {
      const message = error.message
      thunkAPI.dispatch(setMessage(message))
      return rejectWithValue(error.message)
    }
  })

export const retrieveImgDatas = createAsyncThunk(
  'imgData/getImgs', async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    try {
      const res = await CurdService.getAll(modle);
      return (res.data)
    } catch (error) {
      const message = error.message
      thunkAPI.dispatch(setMessage(message))
      return rejectWithValue(error.message)
    }
  })

export const retrieveImgDataById = createAsyncThunk(
  'imgData/retrieveImgById', async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    try {
      const res = await CurdService.get(modle, id);
      return (res.data)
    } catch (error) {
      const message = error.message
      thunkAPI.dispatch(setMessage(message))
      return rejectWithValue(error.message)
    }
  })

export const updateImgData = createAsyncThunk(
  'imgData/updateImg', async (arg, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    const { id, data } = arg
    try {
      const res = await CurdService.update(modle, id, data)
      return (res.data)
    } catch (error) {
      const message = error.message
      thunkAPI.dispatch(setMessage(message))
      return rejectWithValue(error.message)
    }
  })

export const deleteImgData = createAsyncThunk(
  'imgData/delImg', async (arg, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    const { id, imgUrl } = arg
    try {
      const res = await CurdService.remove(modle, `${id}`)
      await CurdService.removeImg(imgUrl)
      return (res.data)
    } catch (error) {
      const message = error.message
      thunkAPI.dispatch(setMessage(message))
      return rejectWithValue(error.message)
    }
  })

const imgDataSlice = createSlice({
  name: 'imgdata',
  initialState: { isloading: false, img: [], message: '' },
  reducers: {
    clearCatMessage: (state, action) => {
      state.message = ''
    },
    addImgData: (state, action) => {
      state.img = state.img.push(action.payload)
    }
  },
  extraReducers: (builder) => {
    builder
      // Create ImgData
      .addCase(createImgData.pending, (state,) => {
        state.isloading = true
      })
      .addCase(createImgData.fulfilled, (state, action) => {
        state.isloading = false;
        state.img = action.payload;
      })
      .addCase(createImgData.rejected, (state, action) => {
        state.isloading = false
        state.message = action.payload
      })
      // Get All ImgData
      .addCase(retrieveImgDatas.pending, (state, action) => {
        state.isloading = true
      })
      .addCase(retrieveImgDatas.fulfilled, (state, action) => {
        state.isloading = false;
        if (Object.keys(action.payload).length !== 0) {
          state.img = action.payload;
        }
      })
      .addCase(retrieveImgDatas.rejected, (state, action) => {
        state.isloading = false
        state.message = action.payload
      })
      // delete ImgData
      .addCase(deleteImgData.pending, (state, action) => {
        state.isloading = true
      })
      .addCase(deleteImgData.fulfilled, (state, action) => {
        state.isloading = false;
/*         state.img = state.img.filter(item => item.id !== action.payload.id)
 */      })
      .addCase(deleteImgData.rejected, (state, action) => {
        state.isloading = false
        state.message = action.payload
      })
      //retrieve One ImgData By Id
      .addCase(retrieveImgDataById.pending, (state, action) => {
        state.isloading = true
      })
      .addCase(retrieveImgDataById.fulfilled, (state, action) => {
        state.isloading = false;
        if (Object.keys(action.payload).length !== 0) {
          state.img = action.payload;
        }
      })
      .addCase(retrieveImgDataById.rejected, (state, action) => {
        state.isloading = false
        state.message = action.payload
      })
      //Update ImgData 
      .addCase(updateImgData.pending, (state, action) => {
        state.isloading = true
      })
      .addCase(updateImgData.fulfilled, (state, action) => {
        state.isloading = false;
        if (action.payload.message) {
          state.message = action.payload.message
        } else {
          return
        }
      })
      .addCase(updateImgData.rejected, (state, action) => {
        state.isloading = false
        state.message = action.payload
      })
  },
})

export const { clearCatMessage, addImgData } = imgDataSlice.actions
export default imgDataSlice.reducer